import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5a745fe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "auth-form"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Установите новый пароль", -1))
const _hoisted_3 = { class: "auth-form-components" }
const _hoisted_4 = { class: "form-block password" }
const _hoisted_5 = { class: "flex flex-col input-labeled" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "newPassword" }, "Новый пароль", -1))
const _hoisted_7 = { class: "flex flex-col input-labeled" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "newPasswordDouble" }, "Подтверждение нового пароля", -1))
const _hoisted_9 = {
  key: 0,
  class: "bad-msg"
}
const _hoisted_10 = {
  key: 1,
  class: "bad-msg"
}
const _hoisted_11 = {
  key: 0,
  class: "fl-senter m-t-5"
}
const _hoisted_12 = {
  key: 1,
  class: "auth-form"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Новый пароль", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-t-8" }, "Новый пароль успешно сохранен.", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

import { ref, watch } from "vue";

import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "@/store/auth/login";
import { rootGetters } from "@/main";

import Button from "primevue/button";
import ProgressSpinner from "primevue/progressspinner";
import Password from "primevue/password";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewPasswordForm',
  emits: ["goToLK"],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const authStore = useAuthStore();
const route = useRoute();
const isProgress = ref(false);
const endForm = ref(false);
const password = ref({
  newPassword: "",
  doubleNewPassword: "",
});
const invalid = ref(false);
const invalidLength = ref(false);
const router = useRouter();
const debounceTimeout = ref(null as number | null);

const sendItemRequest = () => {
  if (password.value.doubleNewPassword != password.value.newPassword) {
    invalid.value = true;
  } else invalid.value = false;
};

watch(
  () => password.value.newPassword,
  () => {
    if (password.value.newPassword.length >= 8) invalidLength.value = false;
  }
);

watch(
  () => password.value.doubleNewPassword,
  () => {
    if (debounceTimeout.value) clearTimeout(debounceTimeout.value);
    debounceTimeout.value = setTimeout(sendItemRequest, 1000);

    if (password.value.doubleNewPassword.length >= 8)
      invalidLength.value = false;
  }
);

watch(
  () => password.value.newPassword,
  () => {
    if (password.value.doubleNewPassword != "") {
      if (debounceTimeout.value) clearTimeout(debounceTimeout.value);
      debounceTimeout.value = setTimeout(sendItemRequest, 1000);
    }
  }
);

function changePassword() {
  invalidLength.value = false;

  if (invalid.value) {
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Проверьте, что пароли совпадают.`
    );
    return;
  }

  if (password.value.newPassword.length < 8) {
    invalidLength.value = true;
    return;
  }

  isProgress.value = true;

  if (route.query && route.query.nonce)
    authStore
      .resetPasswordConfirm(
        route.query.nonce.toString(),
        password.value.newPassword
      )
      .then(() => {
        endForm.value = true;
        localStorage.removeItem("recoveryEmail");
        localStorage.removeItem("sendingEnabled");
        emits("goToLK");
        setTimeout(() => {
          router.push({ name: "personalAccount" });
        }, 3000);
      })
      .catch((err) => {
        if (err.response && err.response.status == 400)
          rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
        else
          rootGetters.toast.show(
            "error",
            "Произошла ошибка",
            `Обратитесь к администратору или проверьте соединение с интернетом.`
          );
      })
      .finally(() => {
        isProgress.value = false;
      });
}

return (_ctx: any,_cache: any) => {
  return (!endForm.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_unref(Password), {
                id: "newPassword",
                modelValue: password.value.newPassword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password.value.newPassword) = $event)),
                placeholder: "Введите новый пароль",
                feedback: false,
                toggleMask: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_unref(Password), {
                id: "newPasswordDouble",
                modelValue: password.value.doubleNewPassword,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password.value.doubleNewPassword) = $event)),
                placeholder: "Введите новый пароль",
                feedback: false,
                toggleMask: "",
                invalid: invalid.value
              }, null, 8, ["modelValue", "invalid"])
            ]),
            (invalid.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Пароли не совпадают"))
              : _createCommentVNode("", true),
            (invalidLength.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Пароль должен содержать хотя бы 8 символов "))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_unref(Button), {
            label: "Установить пароль",
            class: "form-button",
            onClick: changePassword,
            disabled: isProgress.value
          }, null, 8, ["disabled"])
        ]),
        (isProgress.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_unref(ProgressSpinner), {
                "aria-label": "Loading",
                style: {"width":"30px","height":"30px"},
                strokeWidth: "2",
                fill: "var(--surface-ground)"
              })
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
}
}

})